@if (pageReady) {
  <main class="">
    <form [formGroup]="emailForm" class="fup-form">
      <mat-form-field class="gs-form-field email-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label id="emailLabel">{{ pageLabels.emailLabelText }}</mat-label>
        <input
          matInput
          class="custom-input"
          formControlName="email"
          id="email"
          aria-labelledby="emailLabel emailError"
          (blur)="confirmEmailsMatch()"
        />
        @if (emailForm.get("email")?.hasError("required")) {
          <mat-error id="emailError">{{ pageLabels.emailRequiredText }}</mat-error>
        } @else if (emailForm.get("email")?.hasError("email")) {
          <mat-error id="emailError">{{ pageLabels.emailValidFormatText }}</mat-error>
        } @else if (emailForm.get("email")?.hasError("emailsDontMatch")) {
          <mat-error id="emailMisMatchError">{{ pageLabels.emailValidMatchText }}</mat-error>
        }
      </mat-form-field>
      @if (emailData.showConfirmEmail) {
        <mat-form-field class="gs-form-field email-field" appearance="outline" subscriptSizing="dynamic">
          <mat-label id="emailConfirmLabel">{{ pageLabels.emailConfirmEmailText }}</mat-label>
          <input
            matInput
            class="custom-input"
            formControlName="emailConfirm"
            id="emailConfirm"
            aria-labelledby="emailConfirmLabel"
            aria-describedby="emailConfirmError emailConfirmMisMatchError"
            (blur)="confirmEmailsMatch()"
          />
          @if (emailForm.get("emailConfirm")?.hasError("required")) {
            <mat-error id="emailConfirmError">{{ pageLabels.emailRequiredText }}</mat-error>
          } @else if (emailForm.get("emailConfirm")?.hasError("email")) {
            <mat-error id="emailConfirmError">{{ pageLabels.emailValidFormatText }}</mat-error>
          } @else if (emailForm.get("emailConfirm")?.hasError("emails2DontMatch")) {
            <mat-error id="emailConfirmMisMatchError">{{ pageLabels.emailValidMatchText }}</mat-error>
          }
        </mat-form-field>
      }
    </form>
  </main>
}
